import { InjectionToken } from '@angular/core';
import { AuthConfig } from './auth.interface';

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AuthConfig');



// WEBPACK FOOTER //
// ./src/@freelancer/auth/auth.config.ts